<template>
  <div>
      <div class="columns is-vcentered is-multiline">
        <div v-for="(person, index) in people" v-bind:key="index"
          class="column is-one-third-fullhd is-half-desktop is-half-tablet"
        >
          <div class="card">
            <a href="/app-views/profile">
              <div class="media section">
                <div class="media-left is-vcentered">
                  <figure class="image is-128x128 is-100x100-mobile is-84x84-small-mobile">
                    <img class="is-circle" :src="person.imageSrc" alt="">
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-6">{{ person.name }}</p>
                  <p class="subtitle is-7">@{{ person.user }}</p>
                  <div class="content">
                    <address>
                      <strong>{{ person.company }}</strong><br>
                      <i class="fas fa-map-marker"></i>{{ person.addressLine1 }}<br>
                       {{ person.addressLine2 }}<br>
                      <a href="mail:developer@awesome.com">
                        <abbr title="Email">
                          <i class="fas fa-envelope"></i>
                        </abbr> {{ person.email }}
                      </a>
                    </address>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered is-multiline">
        <div v-for="(person, index) in people" v-bind:key="index" class="column is-one-third">
          <div class="card">
            <a href="/app-views/profile">
              <header class="card-header">
                <div class="media section has-text-centered is-centered">
                  <figure class="image is-128x128">
                    <img class="is-circle" :src="person.imageSrc" alt="">
                    <figcaption>
                      <p class="title is-6">{{ person.name }}</p>
                      <p class="subtitle is-7">@{{ person.user }}</p>
                    </figcaption>
                  </figure>
                </div>
              </header>
              <div class="card-content has-text-centered">
                <div class="content">
                  <address>
                    <strong>{{ person.company }}</strong><br>
                    <i class="fa fa-map-marker"></i>{{ person.addressLine1 }}<br>
                    {{ person.addressLine2 }}<br>
                    <a href="mail:developer@awesome.com">
                      <abbr title="Email">
                        <i class="fas fa-envelope"></i>
                      </abbr> developer@awesome.com
                    </a>
                  </address>
                </div>
              </div>
            </a>
            <footer class="card-footer">
              <a href="#" class="card-footer-item">
                <i class="fas fa-phone"></i> &nbsp;Call</a>
              <a href="#" class="card-footer-item">
                <i class="fas fa-envelope"></i> &nbsp;Email</a>
              <a href="#" class="card-footer-item">
                <i class="fas fa-user-plus"></i> &nbsp;Follow</a>
            </footer>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      people: [
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'developer@awesome.com',
          imageSrc: require('./../../../../assets/img/people/person1.jpg'),
        },
        {
          name: 'John Smith',
          user: 'johnsmith',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'johnsmith@dev.com',
          imageSrc: require('./../../../../assets/img/people/person3.jpg'),
        },
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'developer@awesome.com',
          imageSrc: require('./../../../../assets/img/people/person2.jpg'),
        },
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'developer@awesome.com',
          imageSrc: require('./../../../../assets/img/people/person4.jpg'),
        },
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'developer@awesome.com',
          imageSrc: require('./../../../../assets/img/people/person1.jpg'),
        },
        {
          name: 'John Smith',
          user: 'johnsmith',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'johnsmith@dev.com',
          imageSrc: require('./../../../../assets/img/people/person3.jpg'),
        },
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'developer@awesome.com',
          imageSrc: require('./../../../../assets/img/people/person5.jpg'),
        },
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          email: 'developer@awesome.com',
          imageSrc: require('./../../../../assets/img/people/person2.jpg'),
        },
      ],
    };
  },
};
</script>

<style>
a {
  color: #4a4a4a;
}

p {
  font-size: 1em;
}

address {
  font-size: 0.8em;
}

.subtitle:not(:last-child) {
  margin-bottom: 1rem;
  margin-top: -1rem;
}
</style>

<style>
a {
  color: #4a4a4a;
}

p {
  font-size: 0.8em;
}

.is-centered {
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

.card-header {
  padding-top: 1em;
  padding-bottom: 2em;
}
</style>
